import { ca } from '@cian/analytics';
import { IJsonQuery } from 'shared/json_query';

type TBannerAction = 'show_sopr' | 'click_sopr';

function trackBannerEvent(jsonQuery: IJsonQuery, source: string | undefined, action: TBannerAction) {
  ca('eventSite', {
    name: 'oldevent',
    action,
    category: 'trap',
    label: 'purchase_giveaway_banner',
    sc: jsonQuery,
    useLastProducts: true,
    page: {
      pageType: 'Listing',
      listingType: 'list',
      siteType: 'desktop',
      extra: {
        trap_type: 'new_building',
        bannerName: 'purchase_giveaway',
        trapid: 'purchase_giveaway',
        source,
      },
    },
  });
}

export function trackBannerShow(jsonQuery: IJsonQuery, source?: string) {
  trackBannerEvent(jsonQuery, source, 'show_sopr');
}

export function trackBannerClick(jsonQuery: IJsonQuery, source?: string) {
  trackBannerEvent(jsonQuery, source, 'click_sopr');
}
